<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <div class="search-line">
      <div style="display: flex;justify-content: flex-start;">
        <button-add @click="toAddPage" style="margin-right: 10px" />
        <button-delete @deleteSelection="deleteSelection" :value="'删除'" />
      </div>
      <input-search :placeholder="searchPlaceholder" @search="search" />
    </div>
    <table-main :tableHead="tableHead" :tableData="tableData" @changeSelection="changeSelection" @previewStream="previewStream" @goToModifyPage="goToModifyPage" :deleteTipInfo="deleteTipInfo" :operationArr="operationArr" :total="total" :pageNum="pageNum" :pageSize="pageSize" @deleteLine="deleteLine" @changePagination="changePagination" />
  </div>
</template>

<script>
  import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
  import ButtonAdd from '../../../components/common/buttons/button-add'
  import ButtonDelete from '../../../components/Button/ButtonDelete'
  import InputSearch from '../../../components/Input/InputSearch'
  import TableMain from '../../../components/Table/TableMain'
  import {api} from '../../api/InterfaceConfig'
  import {errorHandler} from '../../../utils/errorHandler'
  import {nAlert, nSuccess} from '../../../utils/notice'
  import {bus} from '../../../utils/bus'
  import InputSelect from '../../../components/Input/InputSelect'

  export default {
    components: {
      InputSelect,
      TableMain,
      InputSearch,
      ButtonAdd,
      ButtonDelete,
      Breadcrumb},
    name: 'police-receiver',
    data () {
      return {
        permissionCodes: '',
        breadcrumb: [{
          value: '智慧大脑',
          name: 'interface-config'
        }, {
          value: '屏幕配置'
        }],
        searchPlaceholder: '屏幕名称',
        searchKey: '',
        deleteTipInfo: '是否确认删除该屏幕？',
        tableHead: [{
          prop: 'dashboardName',
          label: '名称'
        }, {
          prop: 'createTime',
          label: '创建时间'
        }],
        tableData: [],
        total: 0,
        pageSize: 10,
        pageNum: 1,
        operationArr: ['previewStream', 'modify', 'delete'],
        selectionArr: [],
        typeList: []
      }
    },
    created () {
      this.permissionCodes = bus.global.permissionCodes
      this.getPage()
    },
    methods: {
      toAddPage () {
        this.$router.push({
          name: 'interface-add'
        })
      },
      getPage () {
        this.$axios.post(api.getDashboardMangerPage, {
          pageSize: this.pageSize,
          pageNum: this.pageNum,
          searchKey: this.searchKey,
        })
          .then(res => {
            if (res.data.retCode === 1) {
              let data = res.data.data.list
              this.total = res.data.data.total
              this.tableData = data
            }
          })
          .catch(errorHandler('获取信息失败'))
      },
      changePagination (data) {
        this.pageNum = data[0]
        this.pageSize = data[1]
        this.getPage()
      },
      searchSelect (v) {
        this.pageNum = 1
        this[v.key] = v.value
        this.getPage()
      },
      search (v) {
        this.pageNum = 1
        this.searchKey = v
        this.getPage()
      },
      changeSelection (codeArr) {
        this.selectionArr = codeArr
      },

      // 修改
      goToModifyPage (code) {
        this.$router.push({
          path: `/interface_modify/${code}`
        })
      },

      deleteSelection () {
        if (this.selectionArr.length === 0) {
          nAlert('请先选择需要删除的屏幕')
          return false
        } else {
          this.$confirm('是否确认删除所选中的屏幕？', '提示')
            .then(() => {
              this.deleteLine(this.selectionArr)
            })
            .catch(() => {
              console.log('取消删除')
            })
        }
      },
      deleteLine (code) {
        this.$axios.post(api.deleteDashboardMangerByCodes, code)
          .then(res => {
            if (res.data.retCode === 1) {
              nSuccess('删除成功')
              this.selectionArr = []
              this.getPage()
            }
          })
          .catch(errorHandler('删除失败'))
      },
      previewStream (data) {
        window.open(`https://yq.damaiiot.com/dataPage.html#/login_without/${bus.global.yqCode}/${bus.global.accountCode}/${data.code}`, '_blank')
      },
    }
  }
</script>

<style scoped>
  .search-line {
    display: flex;
    justify-content: space-between;
    margin: 20px 0;
  }
</style>



// WEBPACK FOOTER //
// src/view/IntellectualBrain/InterfaceManage/InterfaceManage.vue